import React from 'react';
import brochure from '../img/Brochure.jpg';

const Services = () => {
	return (
		<section className="services" id="services">
			<div className="max-width">
				<h2 className="title">Services Offered</h2>
				<div className="services-content">
					<div className="services-img">
						<img src={brochure} />
					</div>
					<br />
					<hr />
					<br />
					<div className="card">
						<div className="box">
							<i className="fas fa-clinic-medical" />
							<div className="text">Clinical Treatment</div>
							<p>
								Skilled in Ayurvedic Management of Allergic Rhinitis, Sciatica, Jaundice, Post Covid
								Management and Fatty Liver
							</p>
						</div>
					</div>
					<div className="card">
						<div className="box">
							<i className="fas fa-stethoscope" />
							<div className="text">Modern Equipment</div>
							<p>
								Skilled in Ayurvedic Management of Allergic Rhinitis, Sciatica, Jaundice, Post Covid
								Management and Fatty Liver
							</p>
						</div>
					</div>
					<div className="card">
						<div className="box">
							<i className="fas fa-prescription" />
							<div className="text">Prescription Medicine</div>
							<p>
								Skilled in Ayurvedic Management of Allergic Rhinitis, Sciatica, Jaundice, Post Covid
								Management and Fatty Liver
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Services;
